export default {
  development: '/api', // 使用代理路径
  test: 'http://localhost:7001',
  production: 'http://www.jiatt.top/api',
}
